module.exports = __webpack_public_path__ + "5e97461c35eb89902e8456ca8ba8a018.svg";